import React, { useState, useEffect } from 'react';
import { Document, Packer, Header, Paragraph, HeightRule,TextRun, convertInchesToTwip,PageNumber,SimpleField,NumberFormat, Table, TableRow, Footer, TableCell, AlignmentType, WidthType, BorderStyle, ImageRun, VerticalAlign, VerticalPositionAlign, VerticalPositionRelativeFrom, HorizontalPositionAlign, HorizontalPositionRelativeFrom, TextWrappingType, } from "docx";
import { saveAs } from "file-saver";
import RelaysCTThreeUpdate from "./RelaysCTThreeUpdate";
import './RelaysCTFour.css';
import { API_URL } from "./API";


function RelaysCTFour({ savedGeneralData, goBack, updateFormData, createDataCell, formData, clearAllFormData, reportToUpdate, isUpdateMode }) {
  const functionalChecksData = [
    "Wiring checks",
    "Correct operation of appropriate indicator /aux. relay",
    "Correct intiation of alarm contacts",
    "Correct circuit breaker tripping contacts",
    "Relay cover properly fixing",
    "Correct operating reset switch",
    "Relay Draw out conditions CT shorting link should be short",
    "All Binary I/O's and LED indications Checked and found ok"
  ];

  const checkListData = [
    "Check the healthiness of fuses, links, MCCB, Switches, indication lamps, push buttons, space heater & illumination circuit",
    "Check broken glass, switch handle, lamp cover etc.",
    "Check all electrical interlock as per scheme.",
    "Check Mounting of all components i.e. Relays, Meters etc.",
    "Check the fuses for correct rating & mounting.",
    "Checking of breaker for free movement.",
    "Scheme checking as per approved drawings.",
    "Checking of all closing and tripping interlocks",
    "Checking of all contacts used for external system."
  ];

  
  const convertDictToArray = (dictData, defaultArray) => {
    if (!dictData || typeof dictData !== 'object') {
      return defaultArray.map(() => "");
    }
    
 
    if (Array.isArray(dictData)) {
      return dictData;
    }
    
   
    const convertedArray = defaultArray.map((description, index) => {
      
      if (dictData[description] !== undefined) {
        return dictData[description] || "";
      }
      
      const values = Object.values(dictData);
      if (values[index] !== undefined) {
        return values[index] || "";
      }
      return "";
    });
    
    return convertedArray;
  };

  const [functionalValues, setFunctionalValues] = useState(() => {
   
    if (isUpdateMode && reportToUpdate?.test_data) {
      try {
        let testData = reportToUpdate.test_data;
        if (typeof testData === 'string') {
          testData = JSON.parse(testData);
        }
        const functionalChecksFromReport = testData.functionalChecksData || testData.f_functionalChecksData || {};
        const converted = convertDictToArray(functionalChecksFromReport, functionalChecksData);
        console.log('Loaded functionalValues from reportToUpdate:', converted);
        return converted;
      } catch (error) {
        console.error('Error parsing functional checks data in RelaysCTFourUpdate:', error);
      }
    }
    
   
    return formData?.functionalChecksData?.length > 0 
      ? formData.functionalChecksData 
      : functionalChecksData.map(() => "");
  });

  const [checkListValues, setCheckListValues] = useState(() => {
   
    if (isUpdateMode && reportToUpdate?.test_data) {
      try {
        let testData = reportToUpdate.test_data;
        if (typeof testData === 'string') {
          testData = JSON.parse(testData);
        }
        const checkListFromReport = testData.checkListData || testData.g_checkListData || {};
        const converted = convertDictToArray(checkListFromReport, checkListData);
        console.log('Loaded checkListValues from reportToUpdate:', converted);
        return converted;
      } catch (error) {
        console.error('Error parsing checklist data in RelaysCTFourUpdate:', error);
      }
    }
    
  
    return formData?.checkListData?.length > 0 
      ? formData.checkListData 
      : checkListData.map(() => "");
  });


  useEffect(() => {
    if (isUpdateMode && reportToUpdate?.test_data) {
      localStorage.setItem('functionalChecksData', JSON.stringify(functionalValues));
      localStorage.setItem('checkListData', JSON.stringify(checkListValues));
    }
  }, []);

  const [showBackPage, setShowBackPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [wordDocDownloaded, setWordDocDownloaded] = useState(false);
  
  const [projectDetails, setProjectDetails] = useState({
    subProjectName: "",
    categoryName: "",
    subcategoryName: "",
    equipmentName: "",
    projectId: "",
    location: ""
  });

  const [allFormData, setAllFormData] = useState({
    formData: {},
    rows: [],
    generalInspection: {},
    settings: {},
    operationalTimeData: {}
  });



  
  // const ALL_STORAGE_KEYS = [
  //   'functionalChecksData',
  //   'checkListData',
  //   'relaysCTFormData',
  //   'updateRelayCurrentMeasurements',
  //   'updateRelayVoltageMeasurements',
  //   'updateRelaySettings',
  //   'relaysCTRowsData',
  //   'updateRelayTestData',
  //   'relaysCTGeneralInspection',
  //   'relaysCTSettings',
  //   'relaysCTOperationalTime',
  //   'createReportData',
  //   'navbarData',
  //   'relaysCTInspectionReportWord',
  //   'relaysCT_autosave',
  //   'relayTestReportWord',
  //   'formSubmissionStatus',
  //   'wordDocDownloadStatus',
  //   'reportCreationCompleted', 
  //   'lastCompletionTimestamp'   
  // ];




  const ALL_STORAGE_KEYS = [
  'functionalChecksData',
  'checkListData',
  'relaysCTFormData',
  'updateRelayCurrentMeasurements',
  'updateRelayVoltageMeasurements',
  'updateRelaySettings',
  'relaysCTRowsData',
  'updateRelayTestData',
  'relaysCTGeneralInspection',
  'relaysCTSettings',
  'relaysCTOperationalTime',
  'updateRelayCTOperationalTimeData',  // Add this
  'createReportData',
  'updateReportData',  // Add this
  'navbarData',
  'relaysCTInspectionReportWord',
  'relaysCT_autosave',
  'relayTestReportWord',
  'formSubmissionStatus',
  'wordDocDownloadStatus',
  'reportCreationCompleted', 
  'lastCompletionTimestamp'   
];


  const clearAllStorageData = () => {
    try {
      console.log("Starting complete localStorage cleanup...");
      
      ALL_STORAGE_KEYS.forEach(key => {
        try {
          localStorage.removeItem(key);
          console.log(`Cleared: ${key}`);
        } catch (error) {
          console.warn(`Could not clear ${key}:`, error);
        }
      });
      
      const prefixes = ['relays', 'relay', 'CT', 'form', 'test', 'report'];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && prefixes.some(prefix => key.toLowerCase().includes(prefix.toLowerCase()))) {
          try {
            localStorage.removeItem(key);
            console.log(`Cleared additional key: ${key}`);
          } catch (error) {
            console.warn(` Could not clear additional key ${key}:`, error);
          }
        }
      }
      
      console.log("Complete localStorage cleanup finished");
      return true;
    } catch (error) {
      console.error("Error during localStorage cleanup:", error);
      return false;
    }
  };

  const resetAllFormStates = () => {
    console.log(" Resetting all form states...");
    
    setFunctionalValues(functionalChecksData.map(() => ""));
    setCheckListValues(checkListData.map(() => ""));
    
    setProjectDetails({
      subProjectName: "",
      categoryName: "",
      subcategoryName: "",
      equipmentName: "",
      projectId: "",
      location: ""
    });

    setAllFormData({
      formData: {},
      rows: [],
      generalInspection: {},
      settings: {},
      operationalTimeData: {}
    });

    setFormSubmitted(false);
    setWordDocDownloaded(false);
    setErrorMessage("");
    setSuccessMessage("");
    setShowBackPage(false);
    
    if (clearAllFormData && typeof clearAllFormData === 'function') {
      try {
        clearAllFormData();
        console.log(" Parent clearAllFormData called successfully");
      } catch (error) {
        console.warn(" Error calling parent clearAllFormData:", error);
      }
    }
    
    console.log(" All form states reset complete");
  };

  const performCompleteCleanup = () => {
    console.log(" Performing complete application cleanup...");
    
    try {
      localStorage.setItem('reportCreationCompleted', 'true');
      localStorage.setItem('lastCompletionTimestamp', Date.now().toString());
    } catch (error) {
      console.warn("Could not set completion flags:", error);
    }
    
    clearAllStorageData();
    resetAllFormStates();
    
    console.log(" Forcing page reload for complete fresh state...");
    setTimeout(() => {
      window.location.href = window.location.pathname;
    }, 500);
  };

  const hasCompletedFullFlow = () => {
    const submitted = formSubmitted;
    const downloaded = wordDocDownloaded;
    const completionFlag = localStorage.getItem('reportCreationCompleted') === 'true';
    
    return submitted && downloaded || completionFlag;
  };

  const checkForCompletedSession = () => {
    try {
      const submissionStatus = localStorage.getItem('formSubmissionStatus');
      const downloadStatus = localStorage.getItem('wordDocDownloadStatus');
      const completionFlag = localStorage.getItem('reportCreationCompleted');
      const lastCompletion = localStorage.getItem('lastCompletionTimestamp');
      
      const recentCompletion = lastCompletion && 
        (Date.now() - parseInt(lastCompletion)) < 5 * 60 * 1000;
      
      const shouldClear = (
        (submissionStatus === 'completed' && downloadStatus === 'completed') ||
        (completionFlag === 'true') ||
        recentCompletion
      );
      
      if (shouldClear) {
        console.log(" Found completed session, performing cleanup...");
        performCompleteCleanup();
        return true;
      }
      
      return false;
    } catch (error) {
      console.error(" Error checking completion status:", error);
      return false;
    }
  };

  const loadDataFromStorage = () => {
    if (checkForCompletedSession()) {
      return; 
    }
    
    try {
      console.log(" Loading data from localStorage...");
      
      const savedFunctionalData = localStorage.getItem('functionalChecksData');
      if (savedFunctionalData) {
        const parsedFunctionalData = JSON.parse(savedFunctionalData);
        if (Array.isArray(parsedFunctionalData) && parsedFunctionalData.length === functionalChecksData.length) {
          setFunctionalValues(parsedFunctionalData);
        }
      }

      const savedCheckListData = localStorage.getItem('checkListData');
      if (savedCheckListData) {
        const parsedCheckListData = JSON.parse(savedCheckListData);
        if (Array.isArray(parsedCheckListData) && parsedCheckListData.length === checkListData.length) {
          setCheckListValues(parsedCheckListData);
        }
      }

      const localNavbarData = localStorage.getItem('navbarData'); 
      const localProjectData = localStorage.getItem('createReportData');
      
      if (localNavbarData) {
        const parsedNavbarData = JSON.parse(localNavbarData);
        if (parsedNavbarData.location) {
          setProjectDetails(prev => ({
            ...prev,
            location: parsedNavbarData.location
          }));
        }
      }
    
      if (localProjectData) {
        const parsedProjectData = JSON.parse(localProjectData);
        setProjectDetails({
          subProjectName: parsedProjectData.sub_project_name || "",
          categoryName: parsedProjectData.category_name || "",
          subcategoryName: parsedProjectData.subcategory_name || "",
          equipmentName: parsedProjectData.equipment_name || "",
          projectId: parsedProjectData.project_id || "",
          location: parsedProjectData.location || (localNavbarData ? JSON.parse(localNavbarData).location || "" : "")
        });
      }
      
      console.log(" Data loading completed");
    } catch (error) {
      console.error(" Error loading data from localStorage:", error);
    }
  };

  useEffect(() => {
    console.log(" Component mounting, checking for completed sessions...");
    
    if (!checkForCompletedSession()) {
      loadDataFromStorage();
    }
  }, []); 

  useEffect(() => {
    if (hasCompletedFullFlow()) {
      console.log("⏸ Skipping auto-save - flow completed");
      return; 
    }

    const autoSave = () => {
      try {
        const formDataToSave = {
          functionalValues: functionalValues,
          checkListValues: checkListValues,
          projectDetails: projectDetails,
          timestamp: new Date().toISOString()
        };
        localStorage.setItem('relaysCT_autosave', JSON.stringify(formDataToSave));
        console.log(" Auto-save completed");
      } catch (error) {
        console.error(" Auto-save failed:", error);
      }
    };

    const autoSaveInterval = setInterval(autoSave, 30000);
    return () => clearInterval(autoSaveInterval);
  }, [functionalValues, checkListValues, projectDetails, formSubmitted, wordDocDownloaded]);

  useEffect(() => {
    if (!hasCompletedFullFlow()) {
      try {
        localStorage.setItem('functionalChecksData', JSON.stringify(functionalValues));
      } catch (error) {
        console.error("Error saving functional checks to localStorage:", error);
      }
    }
  }, [functionalValues, formSubmitted, wordDocDownloaded]);

  useEffect(() => {
    if (!hasCompletedFullFlow()) {
      try {
        localStorage.setItem('checkListData', JSON.stringify(checkListValues));
      } catch (error) {
        console.error("Error saving checklist to localStorage:", error);
      }
    }
  }, [checkListValues, formSubmitted, wordDocDownloaded]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (hasCompletedFullFlow()) {
        console.log("🧹 Page unloading - clearing completed session data");
        clearAllStorageData();
      }
    };

    const handleUnload = () => {
      if (hasCompletedFullFlow()) {
        clearAllStorageData();
      }
    };

    const handleVisibilityChange = () => {
      if (document.hidden && hasCompletedFullFlow()) {
        console.log(" Page hidden - clearing completed session data");
        clearAllStorageData();
      }
    };

    const handleFocus = () => {
      if (checkForCompletedSession()) {
        console.log(" Page focus - found completed session, cleaning up");
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('unload', handleUnload);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleFocus);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleUnload);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
    };
  }, [formSubmitted, wordDocDownloaded]);

  const handleFunctionalChange = (index, value) => {
    if (hasCompletedFullFlow()) {
      console.log(" Form completed - ignoring input change");
      return; 
    }
    
    const newValues = [...functionalValues];
    newValues[index] = value;
    setFunctionalValues(newValues);
    
    try {
      localStorage.setItem('functionalChecksData', JSON.stringify(newValues));
    } catch (error) {
      console.error("Error saving functional checks to localStorage:", error);
    }
  };

  const handleCheckListChange = (index, value) => {
    if (hasCompletedFullFlow()) {
      console.log(" Form completed - ignoring input change");
      return;
    }
    
    const newValues = [...checkListValues];
    newValues[index] = value;
    setCheckListValues(newValues);
    
    try {
      localStorage.setItem('checkListData', JSON.stringify(newValues));
    } catch (error) {
      console.error("Error saving checklist to localStorage:", error);
    }
  };

const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page")) {  
    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";
  }
};


  const createSimpleDictionary = (dataArray, descriptionsArray) => {
    const dictionary = {};
    
    dataArray.forEach((value, index) => {
      if (index < descriptionsArray.length) {
        const description = descriptionsArray[index];
        dictionary[description] = value || "";
      }
    });
    
    return dictionary;
  };

// const handleSave = async (e) => {
//   e.preventDefault();
//   setFormSubmitted(true);
//   setIsLoading(true);
//   setErrorMessage("");
 
//   try {
//     localStorage.setItem('formSubmissionStatus', 'in_progress');
   
//     const functionalChecksDict = createSimpleDictionary(functionalValues, functionalChecksData);
//     const checkListDict = createSimpleDictionary(checkListValues, checkListData);
 
//     console.log("Functional Checks Dictionary:", functionalChecksDict);
//     console.log("CheckList Dictionary:", checkListDict);
 
//     localStorage.setItem('functionalChecksData', JSON.stringify(functionalChecksDict));
//     localStorage.setItem('checkListData', JSON.stringify(checkListDict));
 
//     const loadFormDataSafely = (key, defaultValue = {}) => {
//       try {
//         const data = localStorage.getItem(key);
//         return data ? JSON.parse(data) : defaultValue;
//       } catch (error) {
//         console.warn(`Error parsing ${key} from localStorage:`, error);
//         return defaultValue;
//       }
//     };
 
//     const formData = loadFormDataSafely('updateRelayTestData', {});
//     const currentData = loadFormDataSafely('updateRelayCurrentMeasurements', {});
//     const voltageData = loadFormDataSafely('updateRelayVoltageMeasurements', {});
//     const settingsData = loadFormDataSafely('updateRelaySettings', {});
//     const operationalTimeData = loadFormDataSafely('updateRelayCTOperationalTimeData', {});
//     const navbarData = loadFormDataSafely('navbarData', {});
 
//     const location = String(formData.location || projectDetails.location || navbarData.location || "");
 
//     const convertArrayToDict = (data) => {
//       const convertedData = {};
     
//       for (const [key, value] of Object.entries(data)) {
//         if (Array.isArray(value)) {
//           convertedData[key] = {};
//           value.forEach((item, index) => {
//             if (typeof item === 'object' && item !== null) {
//               for (const [subKey, subValue] of Object.entries(item)) {
//                 if (!convertedData[key][subKey]) {
//                   convertedData[key][subKey] = {};
//                 }
//                 convertedData[key][subKey][`reading_${index + 1}`] = subValue;
//               }
//             } else {
//               convertedData[key][`reading_${index + 1}`] = item;
//             }
//           });
//         } else if (typeof value === 'object' && value !== null) {
//           convertedData[key] = convertArrayToDict(value);
//         } else {
//           convertedData[key] = value;
//         }
//       }
     
//       return convertedData;
//     };
 
//     const convertedFormData = convertArrayToDict(formData || {});
//     const convertedCurrentData = convertArrayToDict(currentData || {});
//     const convertedVoltageData = convertArrayToDict(voltageData || {});
//     const convertedSettingsData = convertArrayToDict(settingsData || {});
//     const convertedOperationalTimeData = convertArrayToDict(operationalTimeData || {});
 
//     console.log("Original data:", {
//       formData, currentData, voltageData, settingsData,
//       operationalTimeData, functionalValues, checkListValues
//     });
   
//     console.log("Converted data:", {
//       convertedFormData, convertedCurrentData, convertedVoltageData,
//       convertedSettingsData, convertedOperationalTimeData,
//       functionalChecksDict, checkListDict
//     });
 
//     const wordBlob = await generateWordBlob();
   
//     if (!wordBlob) {
//       throw new Error("Failed to generate Word document");
//     }
   
//     const reader = new FileReader();
//     reader.readAsDataURL(wordBlob);
   
//     reader.onloadend = async () => {
//       try {
//         const base64data = reader.result;
       
//         if (!base64data) {
//           throw new Error("Failed to convert Word document to base64");
//         }
       
//         localStorage.setItem('relayTestReportWord', base64data);
       
//         const currentDate = new Date().toISOString().split('T')[0];
       
       
//         const getProjectId = () => {
//           console.log("=== Starting project_id extraction ===");
//           console.log("isUpdateMode:", isUpdateMode);
//           console.log("reportToUpdate:", reportToUpdate);
         
       
//           if (isUpdateMode && reportToUpdate && reportToUpdate.project_id) {
//             const id = parseInt(reportToUpdate.project_id);
//             if (!isNaN(id) && id > 0) {
//               console.log("✓ Found project_id in reportToUpdate.project_id:", id);
//               return id;
//             }
//           }
         
       
//           try {
//             const updateReportData = localStorage.getItem('updateReportData');
//             if (updateReportData) {
//               const parsedData = JSON.parse(updateReportData);
//               if (parsedData.project_id) {
//                 const id = parseInt(parsedData.project_id);
//                 if (!isNaN(id) && id > 0) {
//                   console.log("✓ Found project_id in updateReportData:", id);
//                   return id;
//                 }
//               }
//             }
//           } catch (error) {
//             console.error("Error parsing updateReportData:", error);
//           }
         
//           if (savedGeneralData?.projectData?.project_id) {
//             const id = parseInt(savedGeneralData.projectData.project_id);
//             if (!isNaN(id) && id > 0) {
//               console.log("✓ Found project_id in savedGeneralData.projectData:", id);
//               return id;
//             }
//           }
//           console.log("✗ No valid project_id in savedGeneralData:", savedGeneralData);
         
         
//           if (projectDetails.projectId) {
//             const id = parseInt(projectDetails.projectId);
//             if (!isNaN(id) && id > 0) {
//               console.log("✓ Found project_id in projectDetails:", id);
//               return id;
//             }
//           }
//           console.log("✗ No valid project_id in projectDetails:", projectDetails.projectId);
         
         
//           try {
//             const createReportData = localStorage.getItem('createReportData');
//             if (createReportData) {
//               const parsedData = JSON.parse(createReportData);
//               console.log("createReportData from localStorage:", parsedData);
             
//               if (parsedData.project_id) {
//                 const id = parseInt(parsedData.project_id);
//                 if (!isNaN(id) && id > 0) {
//                   console.log(" Found project_id in createReportData:", id);
//                   return id;
//                 }
//               }
//             }
//           } catch (error) {
//             console.error("Error parsing createReportData:", error);
//           }
//           console.log(" No valid project_id in createReportData");
         
       
//           if (convertedFormData.project_id) {
//             const id = parseInt(convertedFormData.project_id);
//             if (!isNaN(id) && id > 0) {
//               console.log(" Found project_id in form data:", id);
//               return id;
//             }
//           }

//           console.log("✗ No valid project_id in form data");
         
         
//           console.error("❌ Could not find valid project_id from any source!");
//           console.error("Available data:", {
//             isUpdateMode,
//             reportToUpdate: reportToUpdate ? {
//               project_id: reportToUpdate.project_id,
//               id: reportToUpdate.id,
//               report_id: reportToUpdate.report_id
//             } : null,
//             savedGeneralData,
//             projectDetails,
//             formData: convertedFormData,
//             updateReportData: localStorage.getItem('updateReportData')
//           });
         
//           throw new Error("Unable to determine project ID. Please ensure project is properly selected.");
//         };
       
//         const projectId = getProjectId();
//         console.log("=== Final project_id selected:", projectId, "===");
       
     
//         console.log("=== Extracting Report ID for Update ===");
//         console.log("isUpdateMode:", isUpdateMode);
//         console.log("reportToUpdate:", reportToUpdate);
        
//         let reportId = null;
        
     
//         if (isUpdateMode && reportToUpdate) {
//           reportId = reportToUpdate.id || reportToUpdate.report_id || reportToUpdate._id;
//           console.log("✓ Report ID from reportToUpdate:", reportId);
//           console.log("  - reportToUpdate.id:", reportToUpdate.id);
//           console.log("  - reportToUpdate.report_id:", reportToUpdate.report_id);
//           console.log("  - reportToUpdate._id:", reportToUpdate._id);
//         }
        
        
//         if (!reportId || reportId === 0 || reportId === '0') {
//           try {
//             const updateReportData = localStorage.getItem('updateReportData');
//             if (updateReportData) {
//               const parsedData = JSON.parse(updateReportData);
//               console.log("✓ Found updateReportData in localStorage:", parsedData);
//               reportId = parsedData.report_id || parsedData.id;
//               console.log("✓ Report ID from localStorage updateReportData:", reportId);
//             } else {
//               console.log("✗ No updateReportData found in localStorage");
//             }
//           } catch (error) {
//             console.error("Error parsing updateReportData:", error);
//           }
//         }
        
      
//         if (!reportId || reportId === 0 || reportId === '0') {
//           console.error("❌ Report ID not found!");
//           console.error("  - isUpdateMode:", isUpdateMode);
//           console.error("  - reportToUpdate:", reportToUpdate);
//           console.error("  - localStorage updateReportData:", localStorage.getItem('updateReportData'));
//           throw new Error("Report ID is required for update operation. Please ensure you are updating an existing report.");
//         }
        
      
//         reportId = parseInt(reportId);
//         if (isNaN(reportId) || reportId <= 0) {
//           console.error("❌ Invalid Report ID:", reportId);
//           throw new Error("Invalid Report ID. Report ID must be a positive number.");
//         }
        
//         console.log("=== Using Report ID:", reportId, "===");
        
//         const apiRequestData = {
//           report_id: reportId,
//           equipment_name: String(projectDetails.equipmentName || convertedFormData.equipment || "Relays CT"),
//           test_date: String(convertedFormData.date || currentDate),
//           category_name: String(projectDetails.categoryName || "Category"),
//           subcategory_name: String(projectDetails.subcategoryName || "Subcategory"),
//           sub_project_name: String(projectDetails.subProjectName || convertedFormData.project || "Project"),
//           project_id: projectId,
//           location: location,
//           report_file: {  
//             report_word: base64data,
//             filename: `RelaysCT_Test_Report_${Date.now()}.docx`,
//             file_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
//           },
//           test_data: {
//             formData: convertedFormData || {},
//             currentData: convertedCurrentData || {},
//             voltageData: convertedVoltageData || {},
//             settingsData: convertedSettingsData || {},
//             operationalTimeData: convertedOperationalTimeData || {},
//             functionalChecksData: functionalChecksDict || {},
//             checkListData: checkListDict || {}
//           }
//         };
 
//         console.log("=== Final API Request Data ===");
//         console.log("Full payload:", JSON.stringify(apiRequestData, null, 2));
//         console.log("Project ID type:", typeof apiRequestData.project_id);
//         console.log("Project ID value:", apiRequestData.project_id);
 
//         const response = await fetch(`${API_URL}/test_report/update_test_report`, {
//           method: 'PUT',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(apiRequestData),
//           mode: 'cors',
//           credentials: 'same-origin',
//         });
 
//         if (!response.ok) {
//           let errorData;
//           try {
//             errorData = await response.json();
//             console.error("Detailed API Error:", errorData);
//           } catch (jsonError) {
//             console.error("Could not parse error response as JSON:", jsonError);
//             errorData = { message: response.statusText };
//           }
         
//           throw new Error(`API error: ${response.status} - ${errorData.message || errorData.detail || response.statusText}`);
//         }
 
//         const result = await response.json();
//         console.log('API Response:', result);
 
//         localStorage.setItem('formSubmissionStatus', 'completed');
//         setSuccessMessage("Data updated successfully");
         
//         alert("Data updated Successfully");
       
//       } catch (error) {
//         console.error("Error in Word document processing or API call:", error);
//         localStorage.setItem('formSubmissionStatus', 'failed');
//         setErrorMessage(`Error: ${error.message}`);
//       } finally {
//         setIsLoading(false);
//       }
//     };
   
//     reader.onerror = (error) => {
//       console.error("FileReader error:", error);
//       localStorage.setItem('formSubmissionStatus', 'failed');
//       setIsLoading(false);
//       setErrorMessage("Error reading Word document file");
//     };
   
//   } catch (error) {
//     console.error("Error saving data:", error);
//     localStorage.setItem('formSubmissionStatus', 'failed');
   
//     if (error.message.includes("Failed to fetch")) {
//       setErrorMessage("Cannot connect to server. Please check if the backend is running.");
//     } else if (error.message.includes("generateWordBlob is not defined")) {
//       setErrorMessage("Word document generation function is missing. Please check your imports.");
//     } else if (error.message.includes("Unable to determine project ID")) {
//       setErrorMessage(error.message);
//       alert(error.message);
//     } else {
//       setErrorMessage(`Error: ${error.message}`);
//     }
//     setIsLoading(false);
//   }
// };
 


const handleSave = async (e) => {
  e.preventDefault();
  setFormSubmitted(true);
  setIsLoading(true);
  setErrorMessage("");

  try {
    // Read fresh data from localStorage
    const freshRelayData = localStorage.getItem('updateRelayTestData');
    const freshCurrentData = localStorage.getItem('updateRelayCurrentMeasurements');
    const freshVoltageData = localStorage.getItem('updateRelayVoltageMeasurements');
    const freshSettingsData = localStorage.getItem('updateRelaySettings');
    const freshOperationalData = localStorage.getItem('updateRelayCTOperationalTimeData');
    const freshFunctionalData = localStorage.getItem('functionalChecksData');
    const freshCheckListData = localStorage.getItem('checkListData');

    let savedRelayData = {};
    let savedCurrentData = {};
    let savedVoltageData = {};
    let savedSettingsData = {};
    let savedOperationalData = {};
    let savedFunctionalData = [];
    let savedCheckListData = [];

    try {
      savedRelayData = freshRelayData ? JSON.parse(freshRelayData) : {};
      console.log("✓ Parsed Relay Data:", savedRelayData);
    } catch (e) {
      console.error("❌ Error parsing Relay data:", e);
    }

    try {
      savedCurrentData = freshCurrentData ? JSON.parse(freshCurrentData) : {};
      console.log("✓ Parsed Current Measurements:", savedCurrentData);
    } catch (e) {
      console.error("❌ Error parsing Current data:", e);
    }

    try {
      savedVoltageData = freshVoltageData ? JSON.parse(freshVoltageData) : {};
      console.log("✓ Parsed Voltage Measurements:", savedVoltageData);
    } catch (e) {
      console.error("❌ Error parsing Voltage data:", e);
    }

    try {
      savedSettingsData = freshSettingsData ? JSON.parse(freshSettingsData) : {};
      console.log("✓ Parsed Settings Data:", savedSettingsData);
    } catch (e) {
      console.error("❌ Error parsing Settings data:", e);
    }

    try {
      savedOperationalData = freshOperationalData ? JSON.parse(freshOperationalData) : {};
      console.log("✓ Parsed Operational Data:", savedOperationalData);
    } catch (e) {
      console.error("❌ Error parsing Operational data:", e);
    }

    try {
      savedFunctionalData = freshFunctionalData ? JSON.parse(freshFunctionalData) : functionalValues;
      console.log("✓ Parsed Functional Data:", savedFunctionalData);
    } catch (e) {
      console.error("❌ Error parsing Functional data:", e);
      savedFunctionalData = functionalValues;
    }

    try {
      savedCheckListData = freshCheckListData ? JSON.parse(freshCheckListData) : checkListValues;
      console.log("✓ Parsed CheckList Data:", savedCheckListData);
    } catch (e) {
      console.error("❌ Error parsing CheckList data:", e);
      savedCheckListData = checkListValues;
    }

    const finalFunctionalData = Array.isArray(savedFunctionalData) ? savedFunctionalData : functionalValues;
    const finalCheckListData = Array.isArray(savedCheckListData) ? savedCheckListData : checkListValues;

    console.log("Final Arrays:");
    console.log("- Functional Array:", finalFunctionalData);
    console.log("- CheckList Array:", finalCheckListData);

    const wordBlob = await generateWordBlob();

    const reader = new FileReader();
    reader.readAsDataURL(wordBlob);

    reader.onloadend = async () => {
      try {
        const dataUrl = reader.result;
        const base64Word = typeof dataUrl === 'string' && dataUrl.includes(',') ? dataUrl.split(',')[1] : dataUrl;
        localStorage.setItem('relayTestReportWord', base64Word);

        let reportId = null;

        if (savedGeneralData?.report_id) {
          reportId = savedGeneralData.report_id;
          console.log("✓ Report ID from savedGeneralData:", reportId);
        } else if (savedGeneralData?.id) {
          reportId = savedGeneralData.id;
          console.log("✓ Report ID from savedGeneralData.id:", reportId);
        } else {
          try {
            const updateReportData = localStorage.getItem('updateReportData');
            if (updateReportData) {
              const parsed = JSON.parse(updateReportData);
              reportId = parsed.report_id || parsed.id;
              console.log("✓ Report ID from updateReportData:", reportId);
            }
          } catch (error) {
            console.error("Error getting report ID from localStorage:", error);
          }
        }

        if (!reportId) {
          throw new Error("Report ID is required for update operation");
        }

        console.log("=== Using Report ID:", reportId, "===");

        const currentDate = new Date().toISOString().split('T')[0];

        const resolveProjectId = () => {
          try {
            const upd = JSON.parse(localStorage.getItem('updateReportData') || 'null');
            const id = upd?.project_id || upd?.report?.project_id || upd?.project?.project_id;
            const n = parseInt(typeof id === 'string' ? id.replace(/\D/g, '') : id);
            if (!isNaN(n) && n > 0) return n;
          } catch { }

          const sg = savedGeneralData || {};
          const sgId = sg.project_id || sg?.projectData?.project_id || sg?.formData?.project_id;
          {
            const n = parseInt(typeof sgId === 'string' ? String(sgId).replace(/\D/g, '') : sgId);
            if (!isNaN(n) && n > 0) return n;
          }

          try {
            const nav = JSON.parse(localStorage.getItem('navbarData') || 'null');
            const n = parseInt(typeof nav?.project_id === 'string' ? nav.project_id.replace(/\D/g, '') : nav?.project_id);
            if (!isNaN(n) && n > 0) return n;
          } catch { }

          try {
            const cr = JSON.parse(localStorage.getItem('createReportData') || 'null');
            const n = parseInt(typeof cr?.project_id === 'string' ? cr.project_id.replace(/\D/g, '') : cr?.project_id);
            if (!isNaN(n) && n > 0) return n;
          } catch { }

          {
            const pid = projectDetails.projectId || savedRelayData?.project_id;
            const n = parseInt(typeof pid === 'string' ? pid.replace(/\D/g, '') : pid);
            if (!isNaN(n) && n > 0) return n;
          }

          throw new Error('Could not determine project_id');
        };

        let existingFilename = `RelaysCT_Test_Report_${Date.now()}.docx`;
        if (savedGeneralData?.report_file?.filename) {
          existingFilename = savedGeneralData.report_file.filename;
        } else {
          try {
            const upd = JSON.parse(localStorage.getItem('updateReportData') || 'null');
            if (upd?.report_file?.filename) {
              existingFilename = upd.report_file.filename;
            }
          } catch { }
        }

        const subProjectName = savedGeneralData?.sub_project_name ||
          (localStorage.getItem('updateReportData') ? JSON.parse(localStorage.getItem('updateReportData')).sub_project_name : "") ||
          projectDetails.subProjectName ||
          savedRelayData?.project ||
          "Project";

        const categoryName = savedGeneralData?.category_name ||
          (localStorage.getItem('updateReportData') ? JSON.parse(localStorage.getItem('updateReportData')).category_name : "") ||
          projectDetails.categoryName ||
          "Relays CT";

        const subCategoryName = savedGeneralData?.subcategory_name ||
          (localStorage.getItem('updateReportData') ? JSON.parse(localStorage.getItem('updateReportData')).subcategory_name : "") ||
          projectDetails.subcategoryName ||
          "Functional Check";

        const equipmentName = savedGeneralData?.equipment_name ||
          (localStorage.getItem('updateReportData') ? JSON.parse(localStorage.getItem('updateReportData')).equipment_name : "") ||
          projectDetails.equipmentName ||
          savedRelayData?.equipment ||
          "Relays CT";

        const apiRequestData = {
          report_id: parseInt(reportId),
          equipment_name: String(equipmentName),
          test_date: String(savedRelayData?.date || currentDate),
          category_name: String(categoryName),
          subcategory_name: String(subCategoryName),
          sub_project_name: String(subProjectName),
          project_id: resolveProjectId(),
          location: String(savedRelayData?.location || projectDetails.location || ""),
          report_file: {
            report_word: base64Word,
            filename: existingFilename,
            file_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          },
          test_data: {
            relayTestData: savedRelayData || {},
            currentMeasurements: savedCurrentData || {},
            voltageMeasurements: savedVoltageData || {},
            relaySettings: savedSettingsData || {},
            operationalTimeData: savedOperationalData || {},
            functionalChecksData: finalFunctionalData,
            checkListData: finalCheckListData
          }
        };

        console.log("=== Final API Request Data ===");
        console.log("Report ID:", apiRequestData.report_id);
        console.log("Test Data Keys:", Object.keys(apiRequestData.test_data));
        console.log("Functional Checks (array):", apiRequestData.test_data.functionalChecksData);
        console.log("CheckList (array):", apiRequestData.test_data.checkListData);

        const apiUrl = `${API_URL}/test_report/update_test_report`;

        const response = await fetch(apiUrl, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(apiRequestData),
          mode: 'cors',
          credentials: 'same-origin',
        });

        console.log("API Response Status:", response.status);

        if (!response.ok) {
          let errorData;
          try {
            errorData = await response.json();
            console.error("Detailed API Error:", errorData);
          } catch (jsonError) {
            const errorText = await response.text();
            console.error("Error response text:", errorText);
            errorData = { message: errorText || response.statusText };
          }

          throw new Error(`API error: ${response.status} - ${errorData.message || errorData.detail || response.statusText}`);
        }

        const result = await response.json();
        console.log('✓ API Response:', result);

        alert("Data updated successfully!");
        setFormSubmitted(true);

      } catch (error) {
        console.error("❌ Error in processing:", error);
        setErrorMessage(`Error: ${error.message}`);
        alert(`Error saving data: ${error.message}`);
      } finally {
        setIsLoading(false);
      }
    };

    reader.onerror = () => {
      console.error("Error reading Word blob");
      setErrorMessage("Error reading Word document");
      setIsLoading(false);
    };

  } catch (error) {
    console.error("❌ Error in handleSave:", error);

    if (error.message.includes("Failed to fetch")) {
      setErrorMessage("Cannot connect to server");
      alert("Cannot connect to server. Please check if the backend is running.");
    } else if (error.message.includes("generateWordBlob is not defined")) {
      setErrorMessage("Word document generation function is missing");
      alert("Word document generation function is missing. Please check your imports.");
    } else {
      setErrorMessage(`Error: ${error.message}`);
      alert(`Error saving data: ${error.message}`);
    }
    setIsLoading(false);
  }
};


const generateWordBlob = () => {
  return new Promise((resolve, reject) => {
    try {
     
      const operationalTimeData = JSON.parse(localStorage.getItem('updateRelayCTOperationalTimeData') || '{}');
      const settingsData = JSON.parse(localStorage.getItem('updateRelaySettings') || '{}');
      const currentMeasurements = JSON.parse(localStorage.getItem('updateRelayCurrentMeasurements') || '{}');
      const voltageMeasurements = JSON.parse(localStorage.getItem('updateRelayVoltageMeasurements') || '{}');
      const storedFormData = JSON.parse(localStorage.getItem('updateRelayTestData') || '{}');

   
      const tableBorders = {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
      };

      
      function findValue(data, searchTerms, defaultValue = "N/A") {
        if (!data || typeof data !== 'object') return defaultValue;
        
        const terms = Array.isArray(searchTerms) ? searchTerms : [searchTerms];
        
        for (let term of terms) {
          if (data[term] !== undefined && data[term] !== null && data[term] !== '') {
            return data[term];
          }
        }
        
        const dataKeys = Object.keys(data);
        for (let term of terms) {
          const termLower = term.toLowerCase();
          for (let key of dataKeys) {
            if (key.toLowerCase() === termLower && data[key] !== undefined && data[key] !== null && data[key] !== '') {
              return data[key];
            }
          }
        }
        
        for (let term of terms) {
          const termLower = term.toLowerCase();
          for (let key of dataKeys) {
            if (key.toLowerCase().includes(termLower) && data[key] !== undefined && data[key] !== null && data[key] !== '') {
              return data[key];
            }
          }
        }
        
        return defaultValue;
      }

      function safeToString(value) {
        if (value === null || value === undefined || value === '' || value === 'N/A') {
          return "";
        }
        return value.toString();
      }

      function safeGetValue(obj, keys, defaultValue = 'N/A') {
        if (!obj || typeof obj !== 'object') return defaultValue;
      
        const keyList = Array.isArray(keys) ? keys : [keys];
      
        for (let key of keyList) {
        
          if (key.includes('.')) {
            const parts = key.split('.');
            let value = obj;
            for (let part of parts) {
              if (value && typeof value === 'object' && part in value) {
                value = value[part];
              } else {
                value = undefined;
                break;
              }
            }
            if (value !== undefined && value !== null && value !== '') {
              return value.toString();
            }
          }
      
         
          if (obj[key] !== undefined && obj[key] !== null && obj[key] !== '') {
            return obj[key].toString();
          }
      
         
          const lowerKey = key.toLowerCase();
          for (let objKey in obj) {
            if (objKey.toLowerCase() === lowerKey) {
              const val = obj[objKey];
              if (val !== undefined && val !== null && val !== '') {
                return val.toString();
              }
            }
          }
        }
      
        return defaultValue;
      }

      const getCurrentValue = (phase, type) => {
        const phaseKey = phase?.toUpperCase(); 
        const typeKey = type?.toLowerCase();   
      
        if (
          currentMeasurements[phaseKey] &&
          currentMeasurements[phaseKey][typeKey]
        ) {
          return currentMeasurements[phaseKey][typeKey].toString();
        }
      
        return 'N/A';
      };

      const getVoltageValue = (phase, type) => {
        const phaseKey = phase?.toUpperCase();  
        const typeKey = type?.toLowerCase();   
      
        if (
          voltageMeasurements[phaseKey] &&
          voltageMeasurements[phaseKey][typeKey]
        ) {
          return voltageMeasurements[phaseKey][typeKey].toString();
        }
      
        return 'N/A';
      };

     
      const getSettingValue = (element, parameter) => {
        const elementKey = element.toLowerCase().replace(/[\/\s]/g, '');
        const parameterKey = parameter.toLowerCase().replace(/\s/g, '');
      
        if (
          settingsData[element] &&
          settingsData[element][parameter]
        ) {
          return settingsData[element][parameter].toString();
        }
      
        const keyOptions = [
          `${element}_${parameter}`,
          `${element}${parameter}`,
          `${elementKey}_${parameterKey}`,
          `${elementKey}${parameterKey}`,
          `${element} ${parameter}`
        ];
      
        const settingValue = safeGetValue(settingsData, keyOptions);
        if (settingValue !== "N/A") return settingValue;
      
        return safeGetValue(storedFormData, keyOptions);
      };

      function getBasicValue(sectionData, fieldSearchTerms, phase) {
        if (!sectionData) return "N/A";
        
     
        const phaseSpecificValue = findValue(sectionData, [
          `${fieldSearchTerms[0]}_${phase}`,
          `${fieldSearchTerms[0]}${phase}`,
          `${phase}_${fieldSearchTerms[0]}`,
          `${phase}${fieldSearchTerms[0]}`
        ]);
        
        if (phaseSpecificValue !== "N/A") return phaseSpecificValue;
        
       
        return findValue(sectionData, fieldSearchTerms);
      }

      function getInjectedFromIndex(data, phase, multiplier) {
        if (!data) return 'N/A';
        
        const fieldMap = {
          '2X': 'injectedCurrent2X',
          '5X': 'injectedCurrent5X',
          '10X': 'injectedCurrent10X'
        };
        
        const fieldName = fieldMap[multiplier];
        if (fieldName && data[fieldName] !== undefined && data[fieldName] !== null && data[fieldName] !== '') {
          return data[fieldName];
        }
        
        return 'N/A';
      }

     
      function getOperatedFromIndex(data, phase, multiplier) {
        if (!data) return 'N/A';
        
        
        const fieldMap = {
          '2X': 'operatedTime2X',
          '5X': 'operatedTime5X',
          '10X': 'operatedTime10X'
        };
        
        const fieldName = fieldMap[multiplier];
        if (fieldName && data[fieldName] !== undefined && data[fieldName] !== null && data[fieldName] !== '') {
          return data[fieldName];
        }
        
        return 'N/A';
      }

    
      let sectionDataOC1 = operationalTimeData['oc1'] || operationalTimeData['OC1'] || operationalTimeData['O/C 1'] || {};
      let sectionDataOC2 = operationalTimeData['oc2'] || operationalTimeData['OC2'] || operationalTimeData['O/C 2'] || {};
      let sectionDataEF1 = operationalTimeData['ef1'] || operationalTimeData['EF1'] || operationalTimeData['E/F 1'] || {};
      let sectionDataEF2 = operationalTimeData['ef2'] || operationalTimeData['EF2'] || operationalTimeData['E/F 2'] || {};
      let sectionDataUV1 = operationalTimeData['uv1'] || operationalTimeData['UV1'] || operationalTimeData['U/V 1'] || {};
      let sectionDataUV2 = operationalTimeData['uv2'] || operationalTimeData['UV2'] || operationalTimeData['U/V 2'] || {};
      let sectionDataOV1 = operationalTimeData['ov1'] || operationalTimeData['OV1'] || operationalTimeData['O/V 1'] || {};
      let sectionDataOV2 = operationalTimeData['ov2'] || operationalTimeData['OV2'] || operationalTimeData['O/V 2'] || {};

     
      const fetchImageAsBase64 = (url) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function() {
            try {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.drawImage(img, 0, 0);
              const dataURL = canvas.toDataURL('image/png');
              const base64 = dataURL.split(',')[1];
              resolve(base64);
            } catch (error) {
              console.warn("Could not convert image to base64:", error);
              resolve(null);
            }
          };
          img.onerror = function() {
            console.warn("Could not load image from URL:", url);
            resolve(null);
          };
          img.src = url;
        });
      };

     
      const documentSections = [];

     

       const createLightWatermark = (base64Data, color ="#1e402c") => {
        return new Promise((resolve) => {
          if (!base64Data) {
            resolve(null);
            return;
          }
          
          try {
            const img = new Image();
            img.onload = function() {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = img.width;
              canvas.height = img.height;
              
             
              ctx.globalAlpha = 0.15; 
              ctx.drawImage(img, 0, 0);
              
              const lightDataURL = canvas.toDataURL('image/png');
              const lightBase64 = lightDataURL.split(',')[1];
              resolve(lightBase64);
            };
            img.onerror = function() {
              resolve(null);
            };
            img.src = 'data:image/png;base64,' + base64Data;
          } catch (error) {
            console.warn("Could not create light watermark:", error);
            resolve(null);
          }
        });
      };

      
      

      
      const logoUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg";
      const watermarkUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg"; 
 

      
      Promise.all([
        fetchImageAsBase64(logoUrl),
        fetchImageAsBase64(watermarkUrl)
      ]).then(([logoBase64, watermarkBase64]) => {
        
       
        createLightWatermark(watermarkBase64, "#1e402c").then((lightWatermarkBase64) => {
        
        
      
        const headerElements = [];

        if (logoBase64) {
          headerElements.push(
            new Table({
              width: { size: 100, type: WidthType.PERCENTAGE },
              rows: [
                new TableRow({
                  children: [
                    new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new ImageRun({
                              data: logoBase64,
                              transformation: {
                                width: 80,
                                height: 80
                              }
                            })
                          ],
                          alignment: AlignmentType.CENTER,
                        })
                      ],
                      verticalAlign: VerticalAlign.CENTER,
                      borders: {
                        top: { style: BorderStyle.SINGLE, size: 1 },
                        bottom: { style: BorderStyle.SINGLE, size: 1 },
                        left: { style: BorderStyle.SINGLE, size: 1 },
                        right: { style: BorderStyle.SINGLE, size: 1 }
                      },
                      width: { size: 20, type: WidthType.PERCENTAGE },
                      margins: {
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0
                      }
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "PIE POWER PRIVATE LIMITED",
                              font: "Times New Roman",
                              color:"#1e402c",
                              bold: true,
                              size: 36
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        }),
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                              font: "helvetica",
                              size: 20
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        }),
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                              font: "helvetica",
                              size: 20
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        })
                      ],
                      borders: {
                        top: { style: BorderStyle.SINGLE, size: 1 },
                        bottom: { style: BorderStyle.SINGLE, size: 1 },
                        left: { style: BorderStyle.SINGLE, size: 1 },
                        right: { style: BorderStyle.SINGLE, size: 1 }
                      },
                      width: { size: 80, type: WidthType.PERCENTAGE }
                    })
                  ]
                })
              ]
            })
          );
        } else {
          
          headerElements.push(
            new Paragraph({
              children: [
                new TextRun({
                  text: "PIE POWER PRIVATE LIMITED",
                  font: "Times New Roman",
                  color:"#1e402c",
                  bold: true,
                  size: 36
                })
              ],
              alignment: AlignmentType.CENTER
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                  font: "helvetica",
                  size: 20
                })
              ],
              alignment: AlignmentType.CENTER
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                  font: "helvetica",
                  size: 20
                })
              ],
              alignment: AlignmentType.CENTER
            })
          );
        }

        headerElements.push(new Paragraph({ text: "" })); 
        documentSections.push(...headerElements);

      
        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  new TableCell({ 
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:   "Description", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({ 
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "RELAYS INSPECTION / TEST REPORT", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    width: { size: 50, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({ 
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:    "Date", font: "Courier New" , bold: true })] })],
                    borders: tableBorders,
                    width: { size: 15, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({ 
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:    safeToString(storedFormData?.date), font: "Courier New" })] })],
                    borders: tableBorders,
                    width: { size: 15, type: WidthType.PERCENTAGE }
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({ 
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:    "Project", font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({ 
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:    safeToString(storedFormData?.project), font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({  
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:   "Report No", font: "Courier New", bold: true  })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({  alignment: AlignmentType.CENTER, children: [new TextRun({ text:    safeToString(storedFormData?.reportNo), font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({  alignment: AlignmentType.CENTER, children: [new TextRun({ text:    "Customer", font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,  children: [new TextRun({ text:    safeToString(storedFormData?.customer), font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                
                  new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text:  " " , font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                   new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text:  " " , font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,  children: [new TextRun({ text:    "Client", font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({  alignment: AlignmentType.CENTER, children: [new TextRun({ text:    safeToString(storedFormData?.client), font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text:  "", font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text:  "", font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              })
            ]
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 

                
        
        
              documentSections.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "LOCATION:",
                        font: "Courier New",
                         bold: true,
                        size: 24
                      }),
                       new TextRun({
                        text: " " + safeToString(storedFormData?.location),
                        font: "Courier New",
                      
                        size: 24
                      })
                    ]
                  })
                );
        
                documentSections.push(new Paragraph({ text: "" })); 
        
       
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "Name Plate Details",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

       
        const nameplateFields = [
          

          { label: "Make", value: storedFormData?.make },
          { label: "Type", value: storedFormData?.type },
          { label: "Serial No", value: storedFormData?.serialNo },
          { label: "Supply Voltage(Uaux)", value: storedFormData?.supplyVoltage },
          { label: "CT Ratio", value: storedFormData?.ctRatio },
          { label: "VT Ratio", value: storedFormData?.vtRatio }
        ];

        const nameplateRows = [];

        nameplateFields.forEach(field => {
          nameplateRows.push(
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER,  children: [new TextRun({ text:    field.label, font: "Courier New", bold: true })] })],
                  borders: tableBorders,
                   width: { size: 50, type: WidthType.PERCENTAGE },
                  shading: {
              fill: "a6a6a6" 
            }
                }),
                new TableCell({
                  children: [new Paragraph({  alignment: AlignmentType.CENTER, children: [new TextRun({ text:    safeToString(field.value), font: "Courier New" })] })],
                  borders: tableBorders,
                   width: { size: 50, type: WidthType.PERCENTAGE }
                })
              ]
            })
          );
        });

        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: nameplateRows
          })
        );

        documentSections.push(new Paragraph({ text: "" }));

      
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "MEASUREMENTS : Current",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

       
        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    width: { size: 20, type: WidthType.PERCENTAGE },
                    shading: {
                      fill: "a6a6a6" 
                    }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Current(Amp)", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 40, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Measured Current(Amp)", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 40, type: WidthType.PERCENTAGE }
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "R", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getCurrentValue('R', 'Injected'), font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getCurrentValue('R', 'Measured'), font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Y", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getCurrentValue('Y', 'Injected'), font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getCurrentValue('Y', 'Measured'), font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "B", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                   
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getCurrentValue('B', 'Injected'), font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getCurrentValue('B', 'Measured'), font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              })
            ]
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 

     
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "MEASUREMENTS : Voltage",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

       
        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    width: { size: 20, type: WidthType.PERCENTAGE },
                    shading: {
                      fill: "a6a6a6" 
                    }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Voltage(V)", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 40, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Measured Voltage(KV)", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 40, type: WidthType.PERCENTAGE }
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "R", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getVoltageValue('R', 'Injected'), font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getVoltageValue('R', 'Measured'), font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Y", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getVoltageValue('Y', 'Injected'), font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getVoltageValue('Y', 'Measured'), font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "B", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                  
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getVoltageValue('B', 'Injected'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getVoltageValue('B', 'Measured'), font: "Courier New" })] })],
                    borders: tableBorders,
                    
                  })
                ]
              })
            ]
          })
        );

        documentSections.push(new Paragraph({ alignment: AlignmentType.CENTER, text: "" })); 

      
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "RELAY SETTINGS",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

      
        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Parameter", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    width: { size: 14, type: WidthType.PERCENTAGE },
                    shading: {
                      fill: "a6a6a6" 
                    }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "O/C 1", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size:10.75, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                    children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "O/C 2", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 10.75, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "E/F 1", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 10.75, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "E/F 2", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 10.75, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "U/V 1", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 10.75, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "U/V 2", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 10.75, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "O/V 1", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 10.75, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "O/V 2", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 10.75, type: WidthType.PERCENTAGE }
                })
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "ANSI Code", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/C 1', 'ANSI Code'), font: "Courier New" })] })],
                    borders: tableBorders,
                    
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/C 2', 'ANSI Code'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('E/F 1', 'ANSI Code'), font: "Courier New" })] })],
                    borders: tableBorders,
                  
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('E/F 2', 'ANSI Code'), font: "Courier New" })] })],
                    borders: tableBorders,
                    
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('U/V 1', 'ANSI Code'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('U/V 2', 'ANSI Code'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/V 1', 'ANSI Code'), font: "Courier New" })] })],
                    borders: tableBorders,
                  
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/V 2', 'ANSI Code'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                })
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Value", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/C 1', 'Set Value'), font: "Courier New" })] })],
                    borders: tableBorders,
                  
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/C 2', 'Set Value'), font: "Courier New" })] })],
                    borders: tableBorders,
                  
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('E/F 1', 'Set Value'), font: "Courier New" })] })],
                    borders: tableBorders,
                 
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('E/F 2', 'Set Value'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('U/V 1', 'Set Value'), font: "Courier New" })] })],
                    borders: tableBorders,
                  
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('U/V 2', 'Set Value'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/V 1', 'Set Value'), font: "Courier New" })] })],
                    borders: tableBorders,
                  
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/V 2', 'Set Value'), font: "Courier New" })] })],
                    borders: tableBorders,
                    
                })
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Curve Type", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/C 1', 'Curve Type'), font: "Courier New" })] })],
                    borders: tableBorders,
                  
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/C 2', 'Curve Type'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('E/F 1', 'Curve Type'), font: "Courier New" })] })],
                    borders: tableBorders,
                  
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('E/F 2', 'Curve Type'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('U/V 1', 'Curve Type'), font: "Courier New" })] })],
                    borders: tableBorders,
                 
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('U/V 2', 'Curve Type'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/V 1', 'Curve Type'), font: "Courier New" })] })],
                    borders: tableBorders,
                   
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/V 2', 'Curve Type'), font: "Courier New" })] })],
                    borders: tableBorders,
                    
                })
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "TIME", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" }
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/C 1', 'TIME'), font: "Courier New" })] })],
                    borders: tableBorders
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/C 2', 'TIME'), font: "Courier New" })] })],
                    borders: tableBorders
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('E/F 1', 'TIME'), font: "Courier New" })] })],
                    borders: tableBorders
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('E/F 2', 'TIME'), font: "Courier New" })] })],
                    borders: tableBorders
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('U/V 1', 'TIME'), font: "Courier New" })] })],
                    borders: tableBorders
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('U/V 2', 'TIME'), font: "Courier New" })] })],
                    borders: tableBorders
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/V 1', 'TIME'), font: "Courier New" })] })],
                    borders: tableBorders
                }),
                new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  getSettingValue('O/V 2', 'TIME'), font: "Courier New" })] })],
                    borders: tableBorders
                })
            ]
        })
    ]
})
);

documentSections.push(new Paragraph({ text: "" })); 


documentSections.push(
    new Paragraph({
        children: [
            new TextRun({
                text: "OPERATIONAL TIME DATA",
                font: "Courier New",
                bold: true,
                size: 24
            })
        ]
    })
);

documentSections.push(new Paragraph({ text: "" })); 


documentSections.push(
    new Table({
        width: { size: 100, type: WidthType.PERCENTAGE },
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Reference", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        width: { size: 16.67, type: WidthType.PERCENTAGE },
                        shading: { fill: "a6a6a6" }
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        width: { size: 16.67, type: WidthType.PERCENTAGE }
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Current(A)", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        width: { size: 16.67, type: WidthType.PERCENTAGE }
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Time(mSec)", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        width: { size: 16.67, type: WidthType.PERCENTAGE }
                    }),
                     new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Current(A)", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        width: { size: 16.67, type: WidthType.PERCENTAGE }
                    }),
                   
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Operated Time(Sec)", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        width: { size: 16.67, type: WidthType.PERCENTAGE }
                    })
                ]
            }),
          
            new TableRow({
                children: [
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "O/C 1", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "a6a6a6" },
                        verticalAlign: VerticalAlign.CENTER
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "R", font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['setCurrent', 'current'], 'R')), font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['setTime', 'time', 'tms'], 'R')), font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['injected', 'injectedCurrent', 'inject'], 'R')), font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['operated', 'operatedTime', 'opTime'], 'R')), font: "Courier New" })] })],
                        borders: tableBorders
                    })
                ]
            }),
         
            new TableRow({
                children: [
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " ", font: "Courier New" })] })],
                        borders: tableBorders,
                        shading: { fill: "a6a6a6" }
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Y", font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['setCurrent', 'current'], 'Y')), font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['setTime', 'time', 'tms'], 'Y')), font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['injected', 'injectedCurrent', 'inject'], 'Y')), font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['operated', 'operatedTime', 'opTime'], 'Y')), font: "Courier New" })] })],
                        borders: tableBorders
                    })
                ]
            }),
            
            new TableRow({
                children: [
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " ", font: "Courier New" })] })],
                        borders: tableBorders,
                        
                        shading: { fill: "a6a6a6" }
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "B", font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['setCurrent', 'current'], 'B')), font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['setTime', 'time', 'tms'], 'B')), font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['injected', 'injectedCurrent', 'inject'], 'B')), font: "Courier New" })] })],
                        borders: tableBorders
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC1, ['operated', 'operatedTime', 'opTime'], 'B')), font: "Courier New" })] })],
                        borders: tableBorders
                    })
                ]
            })
        ]
    })
);

documentSections.push(new Paragraph({ text: "" })); 


documentSections.push(
    new Table({
        width: { size: 100, type: WidthType.PERCENTAGE },
        rows: [
            
            new TableRow({
                children: [
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Reference", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        rowSpan: 2,
                        shading: { fill: "a6a6a6" }
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        rowSpan: 2
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Current(A)", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        rowSpan: 2
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "TMS", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        rowSpan: 2
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Current(A)", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        columnSpan: 3
                    }),
                    new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Operated Time(Sec)", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                    fill: "a6a6a6" 
                  },
                        columnSpan: 3
                    })
                ]
            }),
           
new TableRow({
  children: [
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "2X", font: "Courier New", bold: true })] })],
      borders: tableBorders,
      shading: {
                    fill: "a6a6a6" 
                  },
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "5X", font: "Courier New", bold: true })] })],
      borders: tableBorders,
      shading: {
                    fill: "a6a6a6" 
                  },

    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "10X", font: "Courier New", bold: true })] })],
      borders: tableBorders,
      shading: {
                    fill: "a6a6a6" 
                  },
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "2X", font: "Courier New", bold: true })] })],
      borders: tableBorders,
      shading: {
                    fill: "a6a6a6" 
                  },
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "5X", font: "Courier New", bold: true })] })],
      borders: tableBorders,
      shading: {
                    fill: "a6a6a6" 
                  },
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "10X", font: "Courier New", bold: true })] })],
      borders: tableBorders,
      shading: {
                    fill: "a6a6a6" 
                  },
    })
  ]
}),

new TableRow({
  children: [
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "O/C 2", font: "Courier New", bold: true })] })],
      borders: tableBorders,
      shading: {
                    fill: "a6a6a6" 
                  },
      rowSpan: 3
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "R", font: "Courier New" })] })],
      borders: tableBorders,
      
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC2, ['setCurrent', 'current'], 'R')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC2, ['tms', 'TMS', 'time'], 'R')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataOC2, 'R', '2X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataOC2, 'R', '5X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataOC2, 'R', '10X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataOC2, 'R', '2X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataOC2, 'R', '5X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataOC2, 'R', '10X')), font: "Courier New" })] })],
      borders: tableBorders
    })
  ]
}),

new TableRow({
  children: [
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Y", font: "Courier New" })] })],
      borders: tableBorders
      
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC2, ['setCurrent', 'current'], 'Y')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC2, ['tms', 'TMS', 'time'], 'Y')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataOC2, 'Y', '2X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataOC2, 'Y', '5X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataOC2, 'Y', '10X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataOC2, 'Y', '2X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataOC2, 'Y', '5X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataOC2, 'Y', '10X')), font: "Courier New" })] })],
      borders: tableBorders
    })
  ]
}),

new TableRow({
  children: [
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "B", font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC2, ['setCurrent', 'current'], 'B')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataOC2, ['tms', 'TMS', 'time'], 'B')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataOC2, 'B', '2X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataOC2, 'B', '5X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataOC2, 'B', '10X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataOC2, 'B', '2X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataOC2, 'B', '5X')), font: "Courier New" })] })],
      borders: tableBorders
    }),
    new TableCell({
      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataOC2, 'B', '10X')), font: "Courier New" })] })],
      borders: tableBorders
    })
  ]
})
]
}));

documentSections.push(new Paragraph({ text: "" }));


documentSections.push(
new Table({
  width: {
    size: 100,
    type: WidthType.PERCENTAGE,
  },
  rows: [
  
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Reference", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          width: { size: 16.67, type: WidthType.PERCENTAGE },
          shading: { fill: "a6a6a6" }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Current(A)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Time(mSec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Current(A)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Operated Time(Sec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        })
      ]
    }),
   
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "E/F 1", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "N", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataEF1, ['setCurrent', 'current'], 'N')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataEF1, ['setTime', 'time', 'tms'], 'N')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataEF1, ['injected', 'injectedCurrent', 'inject'], 'N')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataEF1, ['operated', 'operatedTime', 'opTime'], 'N')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    })
  ]
}));

documentSections.push(new Paragraph({ text: "" }));


documentSections.push(
new Table({
  width: {
    size: 100,
    type: WidthType.PERCENTAGE,
  },
  rows: [
   
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Reference", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          rowSpan: 2,
          shading: { fill: "a6a6a6" }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          rowSpan: 2
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Current(A)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          rowSpan: 2
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "TMS", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          rowSpan: 2
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Current(A)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          columnSpan: 3
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Operated Time(Sec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          columnSpan: 3
        })
      ]
    }),
   
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "2X", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "5X", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "10X", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "2X", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "5X", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "10X", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
        })
      ]
    }),
   
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "E/F 2", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: { fill: "a6a6a6" }
          
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "N", font: "Courier New" })] })],
          borders: tableBorders
          
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataEF2, ['setCurrent', 'current'], 'N')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataEF2, ['tms', 'TMS', 'time'], 'N')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataEF2, 'N', '2X')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataEF2, 'N', '5X')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getInjectedFromIndex(sectionDataEF2, 'N', '10X')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataEF2, 'N', '2X')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataEF2, 'N', '5X')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getOperatedFromIndex(sectionDataEF2, 'N', '10X')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    })
  ]
}));

documentSections.push(new Paragraph({ text: "" }));


documentSections.push(new Table({
  width: { size: 100, type: WidthType.PERCENTAGE },
  rows: [
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Reference", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Voltage(V)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Time(mSec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Voltage(V)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Operated Time(Sec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        })
      ]
    }),
  
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "U/V 1", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          verticalAlign: VerticalAlign.CENTER
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "R", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['setVoltage', 'voltage'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['setTime', 'time', 'tms'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['injected', 'injectedVoltage', 'inject'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['operated', 'operatedTime', 'opTime'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    }),
   
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  }
        }),
        new TableCell({
          children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Y", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['setVoltage', 'voltage'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['setTime', 'time', 'tms'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['injected', 'injectedVoltage', 'inject'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['operated', 'operatedTime', 'opTime'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    }),
    
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "B", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['setVoltage', 'voltage'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['setTime', 'time', 'tms'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['injected', 'injectedVoltage', 'inject'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(getBasicValue(sectionDataUV1, ['operated', 'operatedTime', 'opTime'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    })
  ]
}));

documentSections.push(new Paragraph({ text: "" }));


documentSections.push(new Table({
  width: { size: 100, type: WidthType.PERCENTAGE },
  rows: [
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Reference", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Voltage(V)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Time(mSec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Voltage(V)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Operated Time(Sec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        })
      ]
    }),
   
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "U/V 2", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          verticalAlign: VerticalAlign.CENTER
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['setVoltage', 'voltage'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['setTime', 'time', 'tms'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['injected', 'injectedVoltage', 'inject'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['operated', 'operatedTime', 'opTime'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    }),
    
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['setVoltage', 'voltage'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['setTime', 'time', 'tms'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['injected', 'injectedVoltage', 'inject'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['operated', 'operatedTime', 'opTime'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    }),
  
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['setVoltage', 'voltage'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['setTime', 'time', 'tms'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['injected', 'injectedVoltage', 'inject'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataUV2, ['operated', 'operatedTime', 'opTime'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    })
  ]
}));

documentSections.push(new Paragraph({ text: "" }));


documentSections.push(new Table({
  width: { size: 100, type: WidthType.PERCENTAGE },
  rows: [
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Reference", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          width: { size: 16.67, type: WidthType.PERCENTAGE },
          shading: { fill: "a6a6a6" }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Voltage(V)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Time(mSec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Voltage(V)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Operated Time(Sec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        })
      ]
    }),
  
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "O/V 1", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          verticalAlign: VerticalAlign.CENTER
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['setVoltage', 'voltage'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['setTime', 'time', 'tms'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['injected', 'injectedVoltage', 'inject'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['operated', 'operatedTime', 'opTime'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    }),
   
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['setVoltage', 'voltage'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['setTime', 'time', 'tms'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['injected', 'injectedVoltage', 'inject'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['operated', 'operatedTime', 'opTime'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    }),
  
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['setVoltage', 'voltage'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['setTime', 'time', 'tms'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['injected', 'injectedVoltage', 'inject'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV1, ['operated', 'operatedTime', 'opTime'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    })
  ]
}));

documentSections.push(new Paragraph({ text: "" }));


documentSections.push(new Table({
  width: { size: 100, type: WidthType.PERCENTAGE },
  rows: [
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Reference", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          width: { size: 16.67, type: WidthType.PERCENTAGE },
          shading: { fill: "a6a6a6" }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Phase", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Voltage(V)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Set Time(mSec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Injected Voltage(V)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Operated Time(Sec)", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          width: { size: 16.67, type: WidthType.PERCENTAGE }
        })
      ]
    }),
   
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "O/V 2", font: "Courier New", bold: true })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  },
          verticalAlign: VerticalAlign.CENTER
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['setVoltage', 'voltage'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['setTime', 'time', 'tms'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['injected', 'injectedVoltage', 'inject'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['operated', 'operatedTime', 'opTime'], 'R')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    }),
  
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['setVoltage', 'voltage'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['setTime', 'time', 'tms'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['injected', 'injectedVoltage', 'inject'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['operated', 'operatedTime', 'opTime'], 'Y')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    }),
    
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
          borders: tableBorders,
          shading: {
                    fill: "a6a6a6" 
                  }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B", font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['setVoltage', 'voltage'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['setTime', 'time', 'tms'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['injected', 'injectedVoltage', 'inject'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOV2, ['operated', 'operatedTime', 'opTime'], 'B')), font: "Courier New" })] })],
          borders: tableBorders
        })
      ]
    })
  ]
}));


documentSections.push(new Paragraph({ text: "" }));
documentSections.push(new Paragraph({ text: "" }));


documentSections.push(new Paragraph({
  children: [
    new TextRun({
      text: "FUNCTIONAL CHECKS",
      bold: true,
      size: 24,
      font: "Courier New"
    })
  ],
  alignment: AlignmentType.LEFT,
  spacing: { after: 200 }
}));


documentSections.push(new Table({
  width: {
    size: 100,
    type: WidthType.PERCENTAGE
  },
  rows: [
 
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({alignment: AlignmentType.CENTER, 
            children: [new TextRun({ text: "Check", bold: true, font: "Courier New" })],
            
          })],
          borders: tableBorders,
          width: { size: 70, type: WidthType.PERCENTAGE },
          shading: { fill: "a6a6a6" }
        }),
        new TableCell({
          children: [new Paragraph({alignment: AlignmentType.CENTER, 
            children: [new TextRun({ text: "Status", bold: true, font: "Courier New" })],
              shading: {
              fill: "a6a6a6" 
            }
          })],
          borders: tableBorders,
          width: { size: 30, type: WidthType.PERCENTAGE }
        })
      ]
    }),
    
   
    ...functionalChecksData.map((check, index) => 
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: check, font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
                    fill: "a6a6a6" 
                  }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: functionalValues[index] || "N/A", font: "Courier New" })] })],
            borders: tableBorders
          })
        ]
      })
    )
  ]
}));


documentSections.push(new Paragraph({ text: "" }));
documentSections.push(new Paragraph({ text: "" }));


documentSections.push(new Paragraph({
  children: [
    new TextRun({
      text: "CHECK LIST",
      bold: true,
      size: 24,
      font: "Courier New"
    })
  ],
  alignment: AlignmentType.LEFT,
  spacing: { after: 200 }
}));


documentSections.push(new Table({
  width: {
    size: 100,
    type: WidthType.PERCENTAGE
  },
  rows: [
   
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({
            children: [new TextRun({ text: "Check Point", bold: true, font: "Courier New" })],
            alignment: AlignmentType.CENTER
          })],
          borders: tableBorders,
          width: { size: 70, type: WidthType.PERCENTAGE },
          shading: { fill: "a6a6a6" }
        }),
        new TableCell({
          children: [new Paragraph({
            children: [new TextRun({ text: "Status", bold: true, font: "Courier New" })],
            alignment: AlignmentType.CENTER
          })],
            shading: {
              fill: "a6a6a6" 
            },
          borders: tableBorders,
          width: { size: 30, type: WidthType.PERCENTAGE },
         
        })
      ]
    }),
    
   
    ...checkListData.map((check, index) => 
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: check, font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
                    fill: "a6a6a6" 
                  }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: checkListValues[index] || "N/A", font: "Courier New" })] })],
            borders: tableBorders
          })
        ]
      })
    )
  ]
}));


documentSections.push(new Paragraph({ text: "" }));
documentSections.push(new Paragraph({ text: "" })); 

    const convertInchesToTwip = (inches) => {
                    return Math.round(inches * 1440);
                  };
          
                
const footerTable = new Table({
  width: { size: 100, type: WidthType.PERCENTAGE, },
  alignment: AlignmentType.LEFT,
  rows: [
    new TableRow({
      height: { value: convertInchesToTwip(0.5), rule: HeightRule.ATLEAST },
      children: [
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "Pie Power",
                  font: "Courier New",
                  bold: true,
                  size: 18
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        }),
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "TPREL",
                  font: "Courier New",
                  bold: true,
                  size: 18
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        }),
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "TPREL",
                  font: "Courier New",
                  bold: true,
                  size: 18
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        }),
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "TPREL",
                  font: "Courier New",
                  bold: true,
                  size: 18
                }),
                new SimpleField({
                  instruction: "PAGE",
                  children: [
                    new TextRun({
                      text: "1",
                      font: "Courier New",
                      size: 16
                    })
                  ]
                }),
                new SimpleField({
                  instruction: "NUMPAGES",
                  children: [
                    new TextRun({
                      text: "1",
                      font: "Courier New",
                      size: 16
                    })
                  ]
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        })
      ]
    })
  ]
});
 

 
        const pageBorders = {
  pageBorderTop: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  },


  pageBorderRight: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  },
  pageBorderBottom: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  },
  pageBorderLeft: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  }
};

      const doc = new Document({
  sections: [
    {
      properties: {
        page: {
          margin: {
            top: convertInchesToTwip(0.5),
            right: convertInchesToTwip(0.5),
            bottom: convertInchesToTwip(1.0),
            left: convertInchesToTwip(0.5)
          },
          borders: pageBorders,
          pageNumbers: {
            start: 1,
            formatType: NumberFormat.DECIMAL
          }
        }
      },
      footers: {
        default: new Footer({
          children: [
            footerTable,
            new Paragraph({
              children: [
                new TextRun({
                  text: "Page ",
                  font: "Courier New",
                  size: 16
                }),
                new TextRun({
                  children: [PageNumber.CURRENT],
                  font: "Courier New",
                  size: 16
                }),
                new TextRun({
                    text: " of ",
                    font: "Courier New",
                    size: 16
                  }),
               
                new TextRun({
                  children: [PageNumber.TOTAL_PAGES],
                  font: "Courier New",
                  size: 16
                })
              ],
              alignment: AlignmentType.CENTER,
              spacing: {
                before: 200
              }
            })
          ]
        })
      },
      headers: lightWatermarkBase64 ? {
        default: new Header({
          children: [
            new Paragraph({
              children: [
                new ImageRun({
                  data: lightWatermarkBase64,
                  transformation: {
                    width: 500,
                    height: 500
                  },
                  floating: {
                    horizontalPosition: {
                      relative: HorizontalPositionRelativeFrom.PAGE,
                      align: HorizontalPositionAlign.CENTER
                    },
                    verticalPosition: {
                      relative: VerticalPositionRelativeFrom.PAGE,
                      align: VerticalPositionAlign.CENTER
                    },
                    wrap: {
                      type: TextWrappingType.BEHIND_TEXT
                    },
                    allowOverlap: true,
                    behindDocument: true
                  }
                })
              ]
            })
          ]
        })
      } : undefined,
      children: documentSections
    }
  ]
});
          
                 
                  Packer.toBlob(doc).then(blob => {
                    resolve(blob);
                  }).catch(error => {
                    console.error("Error generating Word blob:", error);
                    reject(error);
                  });
                  });
          
                }).catch(error => {
                  console.error("Error fetching logo:", error);
                  reject(error);
                });
          
              } catch (error) {
                console.error("Error generating Word blob:", error);
                reject(error);
              }
            });
          };
   



//  const handleDownloadWordDoc = async () => {
//   setIsLoading(true);
//   setErrorMessage("");
  
//   try {
   
//     const allFormData = JSON.parse(localStorage.getItem('relaysCTFormData') || '{}');

//     const safeFormData = formData && typeof formData === 'object' ? formData : allFormData;
    

//     const wordBlob = await generateWordBlob(safeFormData, checkListValues);
//     saveAs(wordBlob, 'RelaysCT_Inspection_Report.docx');
    

//       localStorage.removeItem('relaysCTFormData');

//       // clearAllStorageData();
//       // resetAllFormStates();
      
//       alert("Word document downloaded successfully");
   
    
//   } catch (error) {
//     console.error("Error generating Word document:", error);
//     setErrorMessage(`Error generating Word document: ${error.message}`);
//   } finally {
//     setIsLoading(false);
//   }
// };


const handleDownloadWordDoc = async () => {
  setIsLoading(true);
  setErrorMessage("");
  
  try {
    const wordBlob = await generateWordBlob();
    saveAs(wordBlob, 'RelaysCT_Inspection_Report.docx');
    
    // Mark as completed and downloaded
    localStorage.setItem('wordDocDownloadStatus', 'completed');
    localStorage.setItem('reportCreationCompleted', 'true');
    localStorage.setItem('lastCompletionTimestamp', Date.now().toString());
    setWordDocDownloaded(true);
    
    alert("Word document downloaded successfully");
    
    // Clear ALL storage data including update-specific keys
    clearAllStorageData();
    
    // Also clear these specific update keys
    const updateKeys = [
      'updateRelayTestData',
      'updateRelayCurrentMeasurements',
      'updateRelayVoltageMeasurements',
      'updateRelaySettings',
      'updateRelayCTOperationalTimeData',
      'updateReportData'
    ];
    
    updateKeys.forEach(key => {
      localStorage.removeItem(key);
    });
    
    // Reset form states
    resetAllFormStates();
    
  } catch (error) {
    console.error("Error generating Word document:", error);
    setErrorMessage(`Error generating Word document: ${error.message}`);
  } finally {
    setIsLoading(false);
  }
};


  const handleBack = () => {
    setShowBackPage(true);
  };
  
  if (showBackPage) {
    return <RelaysCTThreeUpdate 
      goBack={() => setShowBackPage(false)} 
      savedGeneralData={allFormData}
    />;
  }

  return (
    <div className="rt-9107">
      <div className="rt-9107-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>FUNCTIONAL CHECKS</h2>
        
        <span 
          style={{ 
            display: 'flex',
            justifyContent: 'flex-end',
            fontSize: '20px', 
            fontWeight: '600', 
            color: '#333', 
            cursor: 'pointer',
            marginLeft: '10px',
            marginBottom: '50px'
          }}
          onClick={redirectToHome}
        >
          X
        </span>
      </div>
      
      {errorMessage && (
        <div className="rt-9107-error-message" style={{ 
          backgroundColor: '#ffebee', 
          color: '#c62828', 
          padding: '10px', 
          borderRadius: '4px', 
          marginBottom: '15px' 
        }}>
          {errorMessage}
        </div>
      )}

      {successMessage && (
        <div className="rt-9107-success-message" style={{ 
          backgroundColor: '#e8f5e8', 
          color: '#2e7d32', 
          padding: '10px', 
          borderRadius: '4px', 
          marginBottom: '15px' 
        }}>
          {successMessage}
        </div>
      )}

      <div className="rt-9107-checks-section">
        {functionalChecksData.map((item, index) => (
          <div className="rt-9107-check-row" key={`func-${index}`}>
            <div className="rt-9107-check-label">{item}</div>
            <div className="rt-9107-check-input">
              <select 
                value={functionalValues[index] || ''} 
                onChange={(e) => handleFunctionalChange(index, e.target.value)}
                disabled={hasCompletedFullFlow() || isLoading}
                style={{
                  opacity: hasCompletedFullFlow() ? 0.6 : 1,
                  cursor: hasCompletedFullFlow() ? 'not-allowed' : 'pointer'
                }}
                   >
                <option value="">Select</option>
                <option value="OK">OK</option>
                <option value="Not OK">Not OK</option>
              </select>
            </div>
          </div>
        ))}
      </div>

      <div className="rt-9107-header">
        <h2>CHECK LIST</h2>
      </div>

      <div className="rt-9107-check-point-label">Check Point*</div>

       <div className="rt-9107-checks-section">
        {checkListData.map((item, index) => (
          <div className="rt-9107-check-row" key={`list-${index}`}>
            <div className="rt-9107-check-label">{item}</div>
            <div className="rt-9107-check-input">
              <select 
                value={checkListValues[index] || ''} 
                onChange={(e) => handleCheckListChange(index, e.target.value)}
                disabled={hasCompletedFullFlow()}
              >
                <option value="">Select</option>
                <option value="OK">OK</option>
                <option value="Not OK">Not OK</option>
              </select>
            </div>
          </div>
        ))}
      </div>

      <div className="rt-9107-button-container">
        <button type="button" onClick={handleBack} className="rt-9107-back-button" disabled={isLoading || hasCompletedFullFlow()}>
          Back
        </button>
        <button type="button" className="rt-9107-save-button" onClick={handleSave} disabled={isLoading || hasCompletedFullFlow()}>
          {isLoading ? "Processing..." : "Update"}
        </button>
        
        {formSubmitted && (
          <button 
            type="button"
            className="rt-9107-download-button" 
            onClick={handleDownloadWordDoc}
            disabled={isLoading || wordDocDownloaded}
            style={{ 
              marginLeft: '10px', 
              backgroundColor: wordDocDownloaded ? '#cccccc' : '#4CAF50', 
              cursor: (isLoading || wordDocDownloaded) ? 'not-allowed' : 'pointer' 
            }}
          >
            {wordDocDownloaded ? "Downloaded" : (isLoading ? "Generating..." : "Download Word")}
          </button>
        )}
      </div>
    </div>
  );
}

export default RelaysCTFour;